export const MODAL_TYPE_LIKE_LIST = 'like-list';
